export default __webpack_public_path__ + "static/media/alert.df80062e.mp3";